/* tslint:disable */
/* eslint-disable */

/**
 * A named permission granted to a Console user through their MS Entra app roles. Defined once here so backend constants and generated Console constants cannot drift.
 */
export enum Permission {
  PaymentsCreate = 'payments:create',
  PaymentsCancel = 'payments:cancel',
  PaymentsRetry = 'payments:retry',
  PaymentsResubmit = 'payments:resubmit',
  PaymentsPollResponses = 'payments:poll-responses',
  TemplatesManage = 'templates:manage',
  AiChat = 'ai:chat',
  CommentsModerate = 'comments:moderate',
  ExportsClientInvoice = 'exports:client-invoice',
  InvoiceReset = 'invoice:reset',
  InvoiceSend = 'invoice:send',
  InvoiceSendSubfinancing = 'invoice:send-subfinancing',
  EndCustomersMerge = 'end-customers:merge',
  EndCustomersCreate = 'end-customers:create',
  EndCustomersEdit = 'end-customers:edit',
  InvoiceDocsPreview = 'invoice-docs:preview',
  InvoiceDocsGenerate = 'invoice-docs:generate',
  ClientsAssignSeller = 'clients:assign-seller',
  OperationalTasksTestAlert = 'operational-tasks:test-alert',
  ReportsDownload = 'reports:download',
  ReportsManageRecipients = 'reports:manage-recipients',
  InvoiceEditInformation = 'invoice:edit-information',
  InvoiceEditFinances = 'invoice:edit-finances',
  FinancingHoldsPlace = 'financing-holds:place',
  FinancingHoldsRelease = 'financing-holds:release',
  InvoiceAdvance = 'invoice:advance',
  ClientsEditPreferences = 'clients:edit-preferences',
  InvoicesExtract = 'invoices:extract'
}
